export const today = () => new Date().toISOString().slice(0, 10);

export const formatCurrency = (amount) =>
  `$${Number(amount ?? 0).toFixed(2)}`;

export const formatDateAU = (dateStr) =>
  new Date(dateStr).toLocaleString('en-AU', {
    weekday: 'short', year: 'numeric', month: 'short',
    day: 'numeric', hour: '2-digit', minute: '2-digit',
  });
